import { render, staticRenderFns } from "./studentMyclass.vue?vue&type=template&id=dc8250c0&scoped=true"
import script from "./studentMyclass.vue?vue&type=script&lang=js"
export * from "./studentMyclass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8250c0",
  null
  
)

export default component.exports